export const MY_STORED_VALUE = 'MY_STORED_VALUE'
export const STORED_VALUE_CARD_DEFINITION = 'STORED_VALUE_CARD_DEFINITION'



// WEBPACK FOOTER //
// ./src/pages/wx-member/points-mall/my-stored-value/store/mutations-types.js